import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getLink',
  standalone: false,
})
export class GetLinkPipe implements PipeTransform {
  public transform(value: string): string {
    if (!/^(f|ht)tps?:\/\//i.test(value)) {
      return 'http://' + value;
    }
    return value;
  }
}
